// CMS slots for the 'waitlist' page — the standalone /waitlist capture card.
// Concatenated into CMS_SLOTS via ./index.
//
// Added 2026-08-10 (Richie: "Please can I also have CMS access for the wording
// of this email capture"). Every default MUST equal the exact copy the card
// rendered before wiring, so the public page is byte-identical until an admin
// edits it.
//
// Scope note: these slots drive the /waitlist page ONLY. The /sign-up waitlist
// branch renders the same WaitlistForm component but keeps its own literals —
// it sits under its own hero and speaks to someone who tried to create an
// account, so it is a different moment, not a second copy of this one.
//
// What is NOT editable here, deliberately: the field labels + placeholders
// (First name / Email / Artist name / Artform), which are form mechanics rather
// than marketing copy, and the honeypot. The validation messages likewise stay
// in the component so they can't be blanked into silence.
import type { SlotDef } from '../slots';

export const waitlistExtra: SlotDef[] = [
  // ─── Capture card ───────────────────────────────────────────────────────
  {
    key: 'waitlist.eyebrow',
    page: 'waitlist',
    kind: 'markdown',
    label: 'Eyebrow',
    helpText: 'Small monospace line above the headline. Rendered uppercase.',
    default: 'START THE RIPPLE',
  },
  {
    key: 'waitlist.headline',
    page: 'waitlist',
    kind: 'markdown',
    label: 'Headline',
    helpText: 'The page’s main heading. Keep it short — it sets at 24px.',
    default: 'Get Early Access.',
  },
  {
    key: 'waitlist.body',
    page: 'waitlist',
    kind: 'markdown',
    label: 'Supporting line',
    helpText: 'One line under the headline, before the form fields.',
    default: 'Be the first to know when sign-ups open.',
  },
  {
    key: 'waitlist.lead_type_label',
    page: 'waitlist',
    kind: 'markdown',
    label: 'Artist / venue question',
    helpText: 'The label above the two-option toggle.',
    default: "I'm a…",
  },
  {
    key: 'waitlist.lead_type_artist',
    page: 'waitlist',
    kind: 'markdown',
    label: 'Toggle: artist option',
    helpText: 'Left option on the toggle. Shows in Clay when selected.',
    default: 'Artist',
  },
  {
    key: 'waitlist.lead_type_venue',
    page: 'waitlist',
    kind: 'markdown',
    label: 'Toggle: venue option',
    helpText: 'Right option on the toggle. Shows in Tide teal when selected.',
    default: 'Host Venue',
  },
  {
    key: 'waitlist.submit_label',
    page: 'waitlist',
    kind: 'markdown',
    label: 'Button label',
    default: 'Get Early Access',
  },
  // ─── Thank-you state (replaces the card after a successful submit) ───────
  {
    key: 'waitlist.success_eyebrow',
    page: 'waitlist',
    kind: 'markdown',
    label: 'After sending: eyebrow',
    helpText: 'Rendered uppercase, same slot as the eyebrow above.',
    default: "YOU'RE ON THE LIST",
  },
  {
    key: 'waitlist.success_headline',
    page: 'waitlist',
    kind: 'markdown',
    label: 'After sending: headline',
    default: 'Thanks — we’ll be in touch.',
  },
  {
    key: 'waitlist.success_body',
    page: 'waitlist',
    kind: 'markdown',
    label: 'After sending: supporting line',
    default:
      "We'll email you the moment sign-ups open in your area. No spam, ever.",
  },
];
